/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Features_CarouselInputs */

const en_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New features carousel`)
};

const fr_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrousel des nouveautés`)
};

const de_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karussell mit neuen Funktionen`)
};

const it_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carosello delle nuove funzionalità`)
};

const ru_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карусель новых функций`)
};

const es_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrusel de nuevas funciones`)
};

const zh_cn2_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新功能轮播`)
};

const ja_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新機能カルーセル`)
};

const hi_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई सुविधाओं का हिंडोला`)
};

const pt_pt2_new_features_carousel = /** @type {(inputs: New_Features_CarouselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos recursos do carrossel`)
};

/**
* | output |
* | --- |
* | "New features carousel" |
*
* @param {New_Features_CarouselInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_features_carousel = /** @type {((inputs?: New_Features_CarouselInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Features_CarouselInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_features_carousel(inputs)
	if (locale === "de") return de_new_features_carousel(inputs)
	if (locale === "it") return it_new_features_carousel(inputs)
	if (locale === "ru") return ru_new_features_carousel(inputs)
	if (locale === "es") return es_new_features_carousel(inputs)
	if (locale === "zh-CN") return zh_cn2_new_features_carousel(inputs)
	if (locale === "ja") return ja_new_features_carousel(inputs)
	if (locale === "hi") return hi_new_features_carousel(inputs)
	if (locale === "pt-PT") return pt_pt2_new_features_carousel(inputs)
	return en_new_features_carousel(inputs)
});